// STYLES
import { CarouselWrapper, HomePageContainer } from "./HomePageStyled";

// LIBRARIES

// MISC

// COMPONENTS
import CarouselSlider from "components/AlertsCarousel/AlertsCarousel";
import ArticlesSection from "components/ArticlesSection/ArticlesSection";
import CardsSection from "components/CardsSection/CardsSection";
import HomeCarousel from "components/HomeCarousel/HomeCarousel";
import ProductsSections from "components/ProductsSections/ProductsSections";
import DSUAnimation from "view/Home/Animation/Animation";
import SurveyBanner from "./SurveyBanner/SurveyBanner";
import ConsultationBanner from "./ConsultationBanner/ConsultationBanner";
import OpenGovernmentBanner from "./OpenGovernmentBanner/OpenGovernmentBanner";

// CONFIGURATION

const HomePage = () => {
  // PROPERTIES

  // API REQUESTS

  // LIBRARY CONSTANTS

  // STATE CONSTANTS

  // LIFE CYCLE

  // EVENT HANDLERS

  return (
    <HomePageContainer>
      <CarouselWrapper>
        <HomeCarousel />
      </CarouselWrapper>
      <CarouselSlider />
      <SurveyBanner />
      <CardsSection />
      <DSUAnimation />
      <ConsultationBanner />
      <ArticlesSection />
      <ProductsSections />
      <OpenGovernmentBanner />
    </HomePageContainer>
  );
};

export default HomePage;
